export default "__VITE_ASSET__DEwhpuw4__"